module.exports = __webpack_public_path__ + "static/media/shield.842ed322.png";